import { MessageCircle, Send } from "lucide-react";
import { useState } from "react";
import { postJson } from "../lib/api";

export function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [reply, setReply] = useState("Ask anything about EdgeLaunch...");

  const onSend = async () => {
    if (!msg.trim()) return;
    const res = await postJson<{ answer: string }>("/api/chat", { message: msg });
    setReply(res.data?.answer ?? res.error ?? "No response");
    setMsg("");
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-50 inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand text-white shadow-lg"
      >
        <MessageCircle size={20} />
      </button>
    );
  }

  return (
    <section className="fixed bottom-6 right-6 z-50 w-80 rounded-2xl border border-border bg-bg p-3 shadow-2xl">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="font-display text-sm">Edge Assistant</h3>
        <button type="button" onClick={() => setOpen(false)} className="text-xs text-copy/60">Close</button>
      </div>
      <p className="mb-3 rounded-xl bg-surface p-3 text-sm">{reply}</p>
      <div className="flex gap-2">
        <input
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          placeholder="Type your question"
          className="w-full rounded-xl border border-border bg-surface px-3 py-2 text-sm"
        />
        <button type="button" onClick={onSend} className="rounded-xl bg-brand px-3 text-white">
          <Send size={14} />
        </button>
      </div>
    </section>
  );
}
